<template>
    <div class="aba-itens">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <div class="listing-header mb-4">
                <div class="header-buttons">
                </div>
            </div>
            <div class="vertical-flow">
                <div class="registry-wrapper">
                    <div v-if="pedido.tipo != 'B'" class="columns container-critica">
                        <div class="column is-3">
                            <vss-select
                                title="critica"
                                placeholder="selecione"
                                tooltipLabel="tooltip-filtro-criticas-item-pedido"
                                v-model="filtroCriticaSelected"
                                :options="filtroCriticaList"
                                :disabled="isLoading"
                                mlLabels
                                @input="() => carregarDados()"
                            />
                        </div>
                        <div class="icone-critica"
                            @click="abirModalCritica">
                            <div class="contagem" v-if="itensPedidoCritica.length > 0">
                                <span>{{ itensPedidoCritica.length }}</span>
                            </div>
                            <b-icon
                                icon="alert"
                                :type="itensPedidoCritica.length > 0 ? 'is-primary' : 'is-disabled'"
                                size="is-medium"
                                class="is-medium"
                                v-tippy
                                :title="$t('resolver-critica-dos-itens')"
                            />
                        </div>
                    </div>
                    <empty-table-message v-if="isEmpty"/>
                    <pedido-retorno-table
                        v-else-if="isPedidoRetorno"
                        :itensPedido="itensPedido"
                        @idItemPedido="idItemPedido = $event"
                        @idItemPedidoSovis="
                            idItemPedidoSovis = $event
                            carregarItensPedidoDetalhe()
                        "
                        @sortTable="sortTable"
                    />
                    <pedido-table 
                        v-else
                        ref="itemPedidoTable"
                        :tipoPedido="pedido.tipo"
                        :itensPedido="itensPedido"
                        :paramDescontoTriplo="paramDescontoTriplo"
                        :isEditSituacao="isEditSituacao"
                        @idItemPedido="
                            idItemPedido = $event
                            carregarItensPedidoDetalhe()
                        "
                        @sortTable="sortTable"
                        @onChangeCheck="onChangeCheck"
                    />
                    <PaginationViewer 
                        class="mb-0" 
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows" 
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted" 
                        @change="updatePagination" 
                    />
                    <lateral-content v-model="showModalDetalhe" compact>
                        <DetalhesManage
                            class="pt-4"
                            v-if="showModalDetalhe"
                            cameFrom="Itens"
                            :geralData="itensPedidoDetalhe"
                            :gradeData="itensPedidoGradeDetalhe"
                            :hasGrade="hasGrade"
                            @voltar="showModalDetalhe = false"
                        />
                    </lateral-content>
                    <lateral-content v-model="showModalCritica">
                        <CriticaItem
                            class="pt-4"
                            v-if="showModalCritica"
                            :itensPedidoCritica="itensPedidoCritica"
                            cameFrom="Itens"
                            @voltar="
                                showModalCritica = false
                            "
                            @refreshList="onRefreshList"
                        />
                    </lateral-content>
                </div>
                <div v-if="loadingComplete" class="totalizadores">
                    <div class="totalizador">
                        <div :title="valorTotal">
                            {{ $t("valor-total-pedido") }}: 
                            {{ getDecimal(valorTotal, null, true) }}
                        </div>

                        <div v-if="isPedidoRetorno">
                            {{ $t("valor-total-faturado") }}: 
                            {{ getDecimal(pedido.valortotalfat, null, true) }}
                        </div>
                        <div>
                            {{ $t("valor-total-frete") }}: 
                            {{ getDecimal(pedido.valortotalfrete, null, true) }}
                        </div>
                        <div>
                            {{ $t("saldo-gerado-total") }}: 
                            {{ getDecimal(pedido.saldogerado, null, true) }}
                        </div>
                    </div>
                    <div 
                        class="totalizador" 
                        v-if="empresaHasCalculation"
                    >
                        <div 
                            :title="$t('valor-para-calculo')+ ': '+pedido.valoripi"
                            v-if="empresaHasIpiCalculation"
                        >
                            {{ $t("valor-total-ipi") }}: 
                            {{ getDecimal(pedido.valortotalipi, null, true) }}
                        </div>
                        <div 
                            :title="$t('valor-para-calculo')+ ': '+pedido.valorst"
                            v-if="empresaHasStCalculation"
                        >
                            {{ $t("valor-total-st") }}: 
                            {{ getDecimal(pedido.valortotalst, null, true) }}
                        </div>
                    </div>
                    <div
                        class="totalizador">
                        {{ $t("peso-total-pedido") }}: 
                        {{ getDecimal(pedido.pesototal) }}

                        <div v-if="isPedidoRetorno">
                            {{ $t("peso-total-faturado") }}:
                            {{ getDecimal(pedido.pesototalfaturado) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ContainerLoader from "@/components/content/loader/ContainerLoader";

import PedidoTable from "@/components/vendas/pedido/pedido-table/PedidoTable";
import PedidoRetornoTable from "@/components/vendas/pedido/pedido-table/PedidoRetornoTable";
import DetalhesManage from "@/components/vendas/detalhes/DetalhesManage.vue";
import CriticaItem from "../critica/CriticaItem.vue";

export default {
    components: {
        ContainerLoader,
        CriticaItem,
        PedidoTable,
        PedidoRetornoTable,
        DetalhesManage,
    },
    props: {
        isPedidoRetorno: {
            type: Boolean,
            default: false,
        },
        pedido: {
            type: Object,
            default: () => {}
        },
        isEditSituacao: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            clearSelectedItems: false,
            itensPedido: [],
            itensPedidoDetalhe: [],
            itensPedidoGradeDetalhe: [],
            itensPedidoCritica: [],
            itensSelected:[],
            filtroCriticaSelected: {
                id: 2,
                label: 'todos'
            },
            filtroCriticaList: [
                {
                    id: 2,
                    label: 'todos'
                },
                {
                    id: 1,
                    label: 'com-critica'
                },
                {
                    id: 0,
                    label: 'sem-critica'
                }
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            paramDescontoTriplo: null,
            isLoading: false,
            loadingComplete: false,
            isEmpty: false,
            column: "produto",
            order: "asc",
            empresaHasCalculation: false,
            empresaHasIpiCalculation: false,
            empresaHasStCalculation: false,
            valorTotal: 0,
            showModalDetalhe: false,
            showModalCritica: false,
            idItemPedido: 0,
            idItemPedidoSovis: 0,
            hasGrade: false,
            isFromErp: false,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.getConfigParamDescontoTriplo();
    },
    watch:{
        $route: {
            handler() {
                if (this.pedido.idpedido != this.$route.params.id) {
                        this.pagination.perPage =
                    this.pagination.perPageOptions[this.pagination.optionStarted];

                    this.getConfigParamDescontoTriplo();
                }
            },
            deep: true
        }
    },
    methods: {
        onRefreshList() {
            this.carregarDados();
            this.itensPedidoCritica = [];
            this.$refs.itemPedidoTable.clearItensSelecionados();
        },
        getConfigParamDescontoTriplo() {
            const nome = "DESCONTOTRIPLO";
            const idUsuario = 0;
            this.$axios.get(`/config/parametrizacao/${nome}/${idUsuario}.json`)
            .then((result) => {
                this.paramDescontoTriplo = result.data.content || { valor: null };
            })
            .finally((_) => {
                this.carregarDados();
            });
        },
        async carregarDados(currentPage = 1) {
            const resetPagination = currentPage === 1 && this.pagination.currentPage !== 1;
            this.isLoading = true;

            try {
                let response;
                const filtroCritica = this.filtroCriticaSelected.id;

                if (this.isPedidoRetorno) {
                    const params = {
                        idPedidoRetorno: this.pedido.idpedido,
                        idPedido: this.pedido.idpedidosovis,
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        order: this.order,
                        column: this.column
                    };
                    response = await this.$axios.get('/vendas/pedido/return/items.json', { params });
                } else {
                    const params = {
                        tipoCritica: filtroCritica,
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        order: this.order,
                        column: this.column
                    };
                    response = await this.$axios.get(`/vendas/pedido/${this.$route.params.id}/items.json`, { params });
                }

                if (response.status !== 200) {
                    this.$root.showMessage("error", "pedido-detalhes-erro");
                } else {
                    this.itensPedido = response.data.content;
                    this.isEmpty = this.itensPedido.length <= 0;
                    this.pagination.totalRows = response.data.totalElements;

                    this.valorTotal = this.pedido.valortotal == null ?
                        response.totalizador : this.pedido.valortotal;

                    this.calculationOfPesoAndQtde();
                    this.loadTotalizadores();
                }
            } catch (exception) {
                this.isEmpty = true;
                this.$root.showMessage("error", "pedido-detalhes-erro");
            } finally {
                this.pagination.resetPagination = resetPagination;
                this.isLoading = false;
                this.loadingComplete = true;
            }
        },
        onChangeCheck(listaItensSelecionados) {
            this.itensPedidoCritica = this.mapItensCritica(listaItensSelecionados);
        },
        abirModalCritica(){
            if(this.itensPedidoCritica.length === 0) return;

            this.showModalCritica = true;
        },
        mapItensCritica(listaItensSelecionados){
            return listaItensSelecionados
            .filter(item=> item.autorizacaoSituacao === 1)
            .map(item=>{
                return {
                    id: item.id,
                    codigo: item.idprodutoerp,
                    produto: item.produto,
                    critica: item.critica
                }
            });
        },
        calculationOfPesoAndQtde() {
            for (let pedido of this.itensPedido) {
                if (this.isPedidoRetorno) {
                    pedido.pesoxqtdfat = pedido.peso * pedido.qtdefaturado;
                    pedido.pesoxqtd = pedido.peso * pedido.qtde; 
                } else {
                    pedido.peso = pedido.peso * pedido.qtde;
                }
            }
        },
        loadTotalizadores() {
            if (this.pedido.empresa) {
                this.empresaHasIpiCalculation = this.pedido.empresa.calculaipi && this.pedido.empresa.calculaipi == 'S';
                this.empresaHasStCalculation = this.pedido.empresa.calculast && this.pedido.empresa.calculast == 'S';
                this.empresaHasCalculation = this.empresaHasIpiCalculation || this.empresaHasStCalculation;
            }
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            if (this.isPedidoRetorno) {
                this.carregarItensPedido(this.pagination.currentPage);
            } else {
                this.carregarItensPedidoRetorno(this.pagination.currentPage);
            }
        },
        async carregarItensPedidoDetalhe() {
            this.isLoading = true;

            try {
                let response;
                if (this.isPedidoRetorno) {

                    // valida se o item retorno apenas existe no erp
                    this.isFromErp = this.isNull(this.idItemPedidoSovis) || this.idItemPedidoSovis === "0";
                    
                    if (this.isFromErp) {
                        response = await this.$axios.get(`/vendas/pedidoretorno/itensretorno/detalhe/${this.idItemPedido}.json`);
                    } else {
                        response = await this.$axios.get(`/vendas/pedidoretorno/itensretorno/detalhe.json?id=${
                        this.idItemPedido}&idItemPedidoSovis=${this.idItemPedidoSovis}`);
                    }
                } else {
                    response = await this.$axios.get(`/vendas/pedido/itens/detalhe/${this.idItemPedido}.json`);
                }

                this.itensPedidoDetalhe = this.translate(response.data.content);
                
            } catch (exception) {
                this.isEmpty = true;
                this.$root.showMessage("error", "msg-erro-load");
            } finally {
                this.carregarItensPedidoGradeDetalhe();
            }
        },
        translate(content) {
            if (this.isPedidoRetorno && content) {
                const itemPedido = content.itemPedido;
                const itemPedidoRetorno = content;

                const tranlatedItemPedidoRetorno = this.translateItemKeys(itemPedidoRetorno, "itempedidoretorno-");
                const translatedItemPedido = this.translateItemKeys(itemPedido, "itempedido-");

                return { ...tranlatedItemPedidoRetorno, ...translatedItemPedido };
            } else {
                return this.translateItemKeys(content, "itempedido-");
            }
        },
        async carregarItensPedidoGradeDetalhe() {
            try {
                let response;
                if (this.isPedidoRetorno) {

                    if (this.isFromErp) {
                        response = await this.$axios.get(`/vendas/pedidoretorno/itensretorno/detalhe/grade/${this.idItemPedido}.json`);
                    } else {
                        response = await this.$axios.get('/vendas/pedidoretorno/itensretorno/detalhe/grade.json', {
                            params: {
                                idItemPedidoRetorno: this.idItemPedido,
                                idItemPedidoSovis: this.idItemPedidoSovis
                            }
                        });
                    }
                } else {
                    response = await this.$axios.get(`/vendas/pedido/itens/detalhe/grade/${this.idItemPedido}.json`);
                }

                const mappedResponse = this.mapGrade(response.data.content);

                this.itensPedidoGradeDetalhe = mappedResponse;
                this.hasGrade = this.itensPedidoGradeDetalhe.length !== 0;
                
            } catch (exception) {
                this.isEmpty = true;
                this.$root.showMessage("error", "msg-erro-load");
            } finally {
                this.isLoading = false;
                this.showModalDetalhe = true;
            }
        },
        mapGrade(content) {
            if (content) {
                return content.map((tipo) => {
                    return {
                        codigo: tipo.grade.idgradeerp,
                        linha: tipo.grade.gradeLinha.descricao,
                        coluna: tipo.grade.gradeColuna.descricao,
                        qntde: tipo.qtde,
                        observacao: tipo.observacao,
                    };
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-itens {
    padding: 20px 0;
    height: 100%;
}
.header-buttons {
    .save-btn {
        width: 20px;
        height: 43px;
    }
}

.situacao-select div,
.produtivo-select div {
    height: 40px;
}
.container-critica{
    .icone-critica {
        position: relative;
        margin-top: 42px;
        .contagem {
            cursor: pointer;
            position: absolute;
            left: 20px;
            top: -10px;
            background-color: #4CAF50;
            border-radius: 50%;
            line-height: 1;
            min-width: 18px;
            height: 18px;
            margin-top: 0px;
            margin-right: -4px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            span {
                color: #fff;
                font-weight: bold;
                font-size: 10px;
                padding: 25px;
            }
        }
    }
}

.totalizadores {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid $table-border;

    .totalizador {
        margin: 10px 14px;
        color: $darker-gray-color;
    }
}
</style>